// RK 1/28/26 Restore drawer close button behavior (WCAG button stays, add click handler).
document.addEventListener('click', (event) => {
  const closeBtn = event.target.closest('.navigation__control-close');
  if (!closeBtn) return;
  event.preventDefault();

  const navWrap = closeBtn.closest('navigation-wrapper');
  if (navWrap && typeof navWrap.handleDrawerToggleClick === 'function') {
    navWrap.handleDrawerToggleClick(event);
    return;
  }

  const backdrop = (navWrap || document).querySelector('.navigation__backdrop');
  if (backdrop) backdrop.click();
});
